import type { Key } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import IconBolt from '@/shared/icons/NewDesign/IconBolt'
import IconPhone from '@/shared/icons/NewDesign/IconPhone'
import IconShieldPerson from '@/shared/icons/NewDesign/IconShieldPerson'
import {
  pulseContractTabOverrides,
  pulseTabsOverrides,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/styled-components'
import { initialFilters } from '../dashboardV2Data'
import { setFilters } from '../DashboardV2Slice'
import { DashboardV2Filters } from '../types'
import countActiveFilters from './countActiveFilters'

const VERTICALS = [
  { key: 'energie', labelKey: 'subscriptionTable:link_to_energy_text', Icon: IconBolt },
  { key: 'telecom', labelKey: 'subscriptionTable:link_to_telecom_text', Icon: IconPhone },
  { key: 'assurance', labelKey: 'subscriptionTable:link_to_insurance_text', Icon: IconShieldPerson },
]

interface UseOverviewPulseParams {
  filters: DashboardV2Filters
  applicationType: string
  onVerticalChange: (vertical: string) => void
}

const useOverviewPulse = ({ filters, applicationType, onVerticalChange }: UseOverviewPulseParams) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const activeCount = countActiveFilters(filters)

  return {
    verticals: VERTICALS.map(vertical => ({
      key: vertical.key,
      label: t(vertical.labelKey),
      Icon: vertical.Icon,
      active: vertical.key === applicationType,
    })),
    onTabChange: ({ activeKey }: { activeKey: Key }) => onVerticalChange(String(activeKey)),
    tabsOverrides: pulseTabsOverrides(false, applicationType === VERTICALS[0].key),
    tabOverrides: pulseContractTabOverrides,
    activeCount,
    canReset: activeCount > 0,
    resetFilters: () => dispatch(setFilters({ ...initialFilters, details: filters.details })),
  }
}

export default useOverviewPulse
